export const name = 'pagesService' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-pages' as const
